import { useEffect, useRef, useState } from 'react';
import './home.scss';
import RendererController from '../../three/renderer-controller';
import BackButton from '../../components/back-button/back-button';
import LocationIntro from '../../components/location-intro/location-intro';
import CRButton from '../../components/copyright-button/copyright-button';
import { useGlobalStore } from '../../stores/use-global-store';
import Footer from '../../components/footer/footer';
import Tags from '../../components/tags/tags';
import ClickableZone from '../../components/clickable-zone/clickable-zone';
import MusicButton from '../../components/music-button/music-button';
import { reportEvent } from '../../utils/thinking/thinking';

function Home() {
  const homePage = useRef<HTMLDivElement>(null);
  const canvas = useRef<HTMLCanvasElement>(null);
  const [hideFooter, setHideFooter] = useState(true);
  const { camState } = useGlobalStore();
  useEffect(() => {
    let animId = 0;
    const init = () => {
      const ctr = new RendererController(canvas.current!, homePage.current!);
      const anim = (time: number) => {
        animId = requestAnimationFrame(anim);
        ctr.anim(time, 0);
      };
      anim(0);
    };
    const timeoutId = setTimeout(init, 100);
    return () => {
      cancelAnimationFrame(animId);
      clearTimeout(timeoutId);
    };
  }, []);

  const toggleFooter = () => {
    setHideFooter(!hideFooter);
  };

  const onClickLogo = () => {
    let buttonType = '主页面';
    switch (camState) {
      case 0:
        buttonType = '主页面';
        break;
      case 1:
        buttonType = '仙灵岛';
        break;
      case 2:
        buttonType = '苏州城';
        break;
      case 3:
        buttonType = '杭州城';
        break;
      case 4:
        buttonType = '蜀山';
        break;
      case 5:
        buttonType = '归云村';
        break;
    }

    reportEvent('return_button', {
      button_type: buttonType,
    });
    setTimeout(() => {
      window.location.href = 'https://xjsj.cmge.com/home/';
    }, 100);
  };

  return (
    <div className="home fullscreen" ref={homePage}>
      <canvas className="fullscreen" ref={canvas}></canvas>
      <LocationIntro></LocationIntro>
      <Tags></Tags>
      <ClickableZone></ClickableZone>
      <CRButton onClick={toggleFooter} isHide={hideFooter}></CRButton>
      <BackButton />
      <MusicButton />
      <Footer isHide={hideFooter} />
      <div className="logo cursor-pointer" onClick={onClickLogo}></div>
    </div>
  );
}

export default Home;
